import { createFileRoute } from "@tanstack/react-router";

import SubscriptionPage from "./-components/SubscriptionPage";

export const Route = createFileRoute("/_app/_dashboard/subscription/")({
  component: SubscriptionPage,
});
